var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 804,
    height: 316,
    viewBox: "0 0 804 316",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M804 18C804 8.05887 795.941 0 786 0H538C528.059 0 520 8.05888 520 18V124.804C520 135.85 528.954 144.804 540 144.804H551.395C568.85 144.804 583 158.954 583 176.409C583 186.676 591.324 195 601.591 195H786C795.941 195 804 186.941 804 177V18Z",
    fill: "#151521"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 551,
    cy: 175,
    r: 25,
    fill: "#151521"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M549 186H553M549 186L549.5 182H552.5L553 186M549 186H546M553 186H556M540 164H562C562.53 164 563.039 164.211 563.414 164.586C563.789 164.961 564 165.47 564 166V180C564 180.53 563.789 181.039 563.414 181.414C563.039 181.789 562.53 182 562 182H540C539.47 182 538.961 181.789 538.586 181.414C538.211 181.039 538 180.53 538 180V166C538 165.47 538.211 164.961 538.586 164.586C538.961 164.211 539.47 164 540 164Z",
    stroke: "#FFC02F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M518.506 165C518.506 154.507 510 146 499.506 146H20C9.50659 146 1 154.507 1 165V296C1 306.493 9.50659 315 20 315H560C570.493 315 579 306.493 579 296V228C579 217.507 570.493 209 560 209H553.506C534.176 209 518.506 193.33 518.506 174V165Z",
    stroke: "#FFC02F",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApps);
export default __webpack_public_path__ + "static/media/apps.ecace9cce3b09bb9b1d898fcc169728e.svg";
export { ForwardRef as ReactComponent };